// GRS80 / WGS84 metres per degree at a latitude (meridian radius M, prime vertical N)
const A = 6378137, E2 = 0.00669438002290, RAD = Math.PI / 180;
export const mPerLat = (lat) => { const s = Math.sin(lat * RAD); return ((A * (1 - E2)) / (1 - E2 * s * s) ** 1.5) * RAD; };
export const mPerLon = (lat) => { const s = Math.sin(lat * RAD); return ((A * Math.cos(lat * RAD)) / Math.sqrt(1 - E2 * s * s)) * RAD; };

// ellipsoidal distance (m): local M/N at mid latitude for short lines, sphere for long ones
export function geoDist(a, b) {
  const m = (a[0] + b[0]) / 2, d = Math.hypot((b[0] - a[0]) * mPerLat(m), (b[1] - a[1]) * mPerLon(m));
  if (d < 5000) return d;
  const dLat = (b[0] - a[0]) * RAD, dLon = (b[1] - a[1]) * RAD;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(a[0] * RAD) * Math.cos(b[0] * RAD) * Math.sin(dLon / 2) ** 2;
  return 2 * 6371008.8 * Math.asin(Math.sqrt(h));
}

// UTM (ETRS89 ≈ WGS84 at cm level for GRS80) easting/northing -> [lat, lon]
export function utmToLl(E, N, zone = 32) {
  const k0 = 0.9996, e1 = (1 - Math.sqrt(1 - E2)) / (1 + Math.sqrt(1 - E2)), ep2 = E2 / (1 - E2);
  const x = E - 500000, M = N / k0, mu = M / (A * (1 - E2 / 4 - (3 * E2 ** 2) / 64 - (5 * E2 ** 3) / 256));
  const p = mu + (3 * e1 / 2 - (27 * e1 ** 3) / 32) * Math.sin(2 * mu) + ((21 * e1 ** 2) / 16 - (55 * e1 ** 4) / 32) * Math.sin(4 * mu) + ((151 * e1 ** 3) / 96) * Math.sin(6 * mu) + ((1097 * e1 ** 4) / 512) * Math.sin(8 * mu);
  const s = Math.sin(p), c = Math.cos(p), t = Math.tan(p), n1 = A / Math.sqrt(1 - E2 * s * s), r1 = (A * (1 - E2)) / (1 - E2 * s * s) ** 1.5;
  const C = ep2 * c * c, T = t * t, D = x / (n1 * k0);
  const lat = p - ((n1 * t) / r1) * (D * D / 2 - ((5 + 3 * T + 10 * C - 4 * C * C - 9 * ep2) * D ** 4) / 24 + ((61 + 90 * T + 298 * C + 45 * T * T - 252 * ep2 - 3 * C * C) * D ** 6) / 720);
  const lon = (D - ((1 + 2 * T + C) * D ** 3) / 6 + ((5 - 2 * C + 28 * T - 3 * C * C + 8 * ep2 + 24 * T * T) * D ** 5) / 120) / c;
  return [lat / RAD, (zone * 6 - 183) + lon / RAD];
}
